import { defaults, assign } from "lodash";
import { IntendedUseEnum } from "./IntendedUses";
import { DemoInstance, getPowerStatusTextDemoInstance, DemoSnapshotStatusEnum, PowerState, ProvisioningState } from "./DemoInstance";

export class DemoInstanceViewmodel implements DemoInstance {
  constructor(demoInstance: DemoInstance) {
    const powerStateText = getPowerStatusTextDemoInstance(demoInstance.powerState, demoInstance.provisioningState, demoInstance.available);
    demoInstance.powerStateText = powerStateText;
    assign(
      this,
      defaults(demoInstance, {
        id: "",
        link: "",
        name: "",
        title: "",
        owner: "",
        group: "",
        bWebAddress: "",
        creationDate: new Date(),
        powerState: demoInstance.powerState,
        provisioningState: demoInstance.provisioningState,
        regionName: "",
        template: "",
        lastAccess: new Date(),
        available: demoInstance.available,
        powerStateText,
        prospect: "",
        prospectId: "",
        intendedUse: null,
        estimatedTime: 0,
        linkSubHub: "",
        linkAdminPortal: "",
        comment: "",
        templateSuggested: false,
        boardVersion: "",
        relatedAssets: [],
        snapshotLabel: "",
        snapshotCreator: "",
        snapshotStatus: DemoSnapshotStatusEnum.creating
      } as DemoInstance)
    );
  }
  id: string;
  link: string;
  name: string;
  owner: string;
  group: string;
  creationDate: Date;
  powerState: PowerState;
  provisioningState: ProvisioningState;
  regionName: string;
  template: string;
  lastAccess: Date;
  powerStateText: string;
  available: boolean;
  prospect: string;
  prospectId: string;
  intendedUse: IntendedUseEnum | null;
  estimatedTime: number;
  linkSubHub: string;
  linkAdminPortal: string;
  bWebAddress: string;
  title: string;
  comment: string;
  templateSuggested: boolean;
  boardVersion: string;
  relatedAssets: string[];
  snapshotLabel: string;
  snapshotDate?: Date;
  snapshotCreator: string;
  snapshotStatus: DemoSnapshotStatusEnum;
}
